import { message, Spin } from "antd";
import { useTenantCases } from "../../../../../hooks/useTenantCases";
import { StyledCreateCase } from "./styles";
import { useCallback, useState } from "react";
import Modal from "../../../../../components/generic/Modal";
import { parseError } from "../../../../../utils/shared";
import httpClient from "../../../../../api/httpClient";

const CreateCase = ({ onCancel, onOpen }) => {
  const { cases, selectedTenantId, loading } = useTenantCases();
  const [selectedCaseId, setSelectedCaseId] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const onOk = useCallback(async () => {
    try {
      if (!selectedCaseId)
        return message.warning("Please select a case template");

      setSubmitting(true);

      const { data } = await httpClient.get("cases", {
        params: {
          tenant_id: selectedTenantId,
          case_template_id: selectedCaseId,
        },
      });

      onOpen(data);
      onCancel();
    } catch (error) {
      parseError(error);
    } finally {
      setSubmitting(false);
    }
  }, [selectedTenantId, selectedCaseId]);

  return (
    <Modal
      title={"New Case"}
      open
      onCancel={onCancel}
      width={500}
      okText="Open Case"
      onOk={onOk}
      isProcessing={submitting}
    >
      <StyledCreateCase>
        {loading ? (
          <div className="w-100 flex justify-center  ">
            <Spin />
          </div>
        ) : (
          <>
            {cases?.map((c) => (
              <div
                key={c.id}
                className={`ctype-opt ${selectedCaseId === c?.id ? "selected" : ""}`}
                onClick={() => setSelectedCaseId(c?.id)}
              >
                <div className="ctype-icon">{c?.icon_emoji}</div>
                <div className="ctype-info">
                  <div className="ctype-name">{c?.name}</div>
                  <div className="ctype-desc">{c?.description}</div>
                </div>
              </div>
            ))}
          </>
        )}
      </StyledCreateCase>
    </Modal>
  );
};

export default CreateCase;
